import { ComponentProps, FC } from 'react';

export const CoinIcon: FC<ComponentProps<'svg'>> = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="25"
		fill="none"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M20 12.14a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm2 0a10 10 0 1 1-20 0 10 10 0 0 1 20 0Zm-11.56 2.18h3.1l-.14-1.35h-3.24l-.03-.28V12.11l.03-.27h3.38l-.14-1.35h-2.94c.2-.48.49-.86.85-1.13.37-.27.82-.4 1.34-.4.41 0 .72.03.93.1l.94.29.56-1.3a6.02 6.02 0 0 0-2.44-.62c-1.06 0-1.9.28-2.56.85-.66.57-1.1 1.3-1.36 2.21H7.15l.17 1.35H8.5a33.31 33.31 0 0 0-.04.59v.28l.03.26H7.15l.17 1.35H8.7c.22.86.64 1.59 1.26 2.17.61.57 1.47.85 2.59.85a6.09 6.09 0 0 0 2.6-.62l-.67-1.34c-.3.12-.6.22-.9.3-.3.1-.65.13-1.06.13-.53 0-.97-.14-1.32-.42-.33-.28-.6-.63-.77-1.07Z"
			fill="currentColor"
		/>
	</svg>
);
